import React from 'react'
import { EQUIPMENT_TYPE_KEY } from 'apps/marketplace/store/transfixLane/types'
import { ReeferIcon, DryVanIcon, FlatBedIcon, SpecializedDeprecatedIcon } from 'transfix-icons'
import { Tooltip } from 'transfix-ui'

export const getEquipmentIcon = (equipmentKey: EQUIPMENT_TYPE_KEY) => {
  switch (equipmentKey) {
    case EQUIPMENT_TYPE_KEY.OPEN_DECK:
      return <FlatBedIcon />
    case EQUIPMENT_TYPE_KEY.REEFER:
      return <ReeferIcon />
    case EQUIPMENT_TYPE_KEY.SPECIALIZED:
      return <SpecializedDeprecatedIcon />
    default:
      return <DryVanIcon />
  }
}

export const getLargeEquipmentIcon = (
  equipmentKey: EQUIPMENT_TYPE_KEY = EQUIPMENT_TYPE_KEY.DRY_VAN,
  className = 'large',
  id = `equipment-tooltip`
) => {
  switch (equipmentKey) {
    case EQUIPMENT_TYPE_KEY.OPEN_DECK:
      return (
        <Tooltip
          id={`${id}-${EQUIPMENT_TYPE_KEY.OPEN_DECK}`}
          position='bottom'
          effect='solid'
          trigger={<FlatBedIcon className={className} />}>
          Open Deck
        </Tooltip>
      )

    case EQUIPMENT_TYPE_KEY.REEFER:
      return (
        <Tooltip
          id={`${id}-${EQUIPMENT_TYPE_KEY.REEFER}`}
          position='bottom'
          effect='solid'
          trigger={<ReeferIcon className={className} />}>
          Reefer
        </Tooltip>
      )
    case EQUIPMENT_TYPE_KEY.SPECIALIZED:
      return (
        <Tooltip
          id={`${id}-${EQUIPMENT_TYPE_KEY.SPECIALIZED}`}
          position='bottom'
          effect='solid'
          trigger={<SpecializedDeprecatedIcon className={className} />}>
          Specialized
        </Tooltip>
      )
    default:
      return (
        <Tooltip
          id={`${id}-${EQUIPMENT_TYPE_KEY.DRY_VAN}`}
          position='bottom'
          effect='solid'
          trigger={<DryVanIcon className={className} />}>
          Dry Van
        </Tooltip>
      )
  }
}
